import { useState } from "react";
import { Bell, Film, RefreshCw } from "lucide-react";
import { EmptyState, Loading, Modal, ReviewCard } from "../components.jsx";
import { api } from "../api.js";
import { useAsync } from "../hooks.js";
import NotificationsPanel from "./NotificationsPanel.jsx";

export default function FeedPage() {
  const [notifications, setNotifications] = useState(false);
  const { data, loading, error, reload } = useAsync(() => api("/v1/feed"), []);
  const reviews = data?.reviews || [];
  return (
    <div className="page feed-page">
      <header className="page-header"><div><span className="title-mark" /><h1>Inicio</h1><p>Lo último de la gente que sigues y de ti.</p></div><div className="header-actions"><button className="icon-button" onClick={reload} aria-label="Actualizar"><RefreshCw /></button><button className="icon-button notification-button" onClick={() => setNotifications(true)} aria-label="Notificaciones"><Bell /></button></div></header>
      {loading ? <Loading label="Preparando tu feed…" /> : error ? <EmptyState title="No se ha podido cargar" text={error} action={<button className="secondary-button" onClick={reload}>Reintentar</button>} /> : reviews.length ? <div className="review-list">{reviews.map((review) => <ReviewCard review={review} key={review.id} />)}</div> : <EmptyState icon={Film} title="Tu feed está tranquilo" text="Sigue a gente desde Buscar o publica tu primera reseña." />}
      {notifications ? <Modal title="Notificaciones" fullMobile onClose={() => setNotifications(false)}><NotificationsPanel /></Modal> : null}
    </div>
  );
}
